<template>
    <div class="d-flex align-items-center justify-content-center vh-100 bg-light">
        <div class="col-md-4">
            <div class="text-center mb-3">
                <img src="@/assets/logo1.png" height="100" alt="Logo" loading="lazy" />
            </div>
            <div class="card login-box shadow bg-transparent">
                <div class="card-body py-5">
                    <h2 class="text-center mb-4 text-primary">CONNEXION</h2>
                    <form @submit.prevent="login()">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa-solid fa-user"></i>
                                </span>
                            </div>
                            <input placeholder="Email" type="email" class="form-control form-control-lg"
                                :class="{ 'is-invalid': success === false }" v-model="form.email" required
                                autocomplete="email" autofocus>
                        </div>

                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa-solid fa-lock"></i>
                                </span>
                            </div>
                            <input placeholder="Mot de passe" :type="showPassword ? 'text' : 'password'"
                                class="form-control form-control-lg" :class="{ 'is-invalid': success === false }"
                                v-model="form.password" required autocomplete="current-password">
                        </div>

                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" id="showPassword" v-model="showPassword">
                            <label class="form-check-label" for="showPassword">Afficher le mot de passe</label>
                        </div>

                        <div class="text-center">
                            <button type="submit" class="btn btn-lg btn-primary btn-block" :disabled="isLoading">
                                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status"
                                    aria-hidden="true"></span>
                                Connexion
                            </button>
                            <router-link :to="{ name: 'forgot_password' }" class="btn btn-link d-block mt-2">
                                Mot de passe oublié ?
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'LoginView',
    data() {
        return {
            isLoading: false,
            showPassword: false,
            success: null,
            user: { type: '' },
            form: {
                email: '',
                password: '',
                source: 'yamsmanager'
            }
        }
    },
    methods: {
        // ...mapActions(['startFetchingNotifications', 'startFetchingMessages']),
        login() {
            this.isLoading = true
            this.axios.post('/api/login', this.form).then(response => {
                this.success = response.data.success
                if (response.data.success === true) {
                    const userDatas = response.data.data
                    const user = userDatas.user
                    if (user.type == 'transporteur' || user.type == 'superadmin') {
                        this.axios.defaults.headers.common = {
                            'Authorization': 'Bearer ' + userDatas.token
                        };
                        this.$store.commit('setAuthenticated', userDatas)
                        // this.startFetchingNotifications();
                        // this.startFetchingMessages();
                        this.$router.push({ name: 'accueil' })
                        this.resetForm()
                    }
                    else {
                        this.$toast.add({
                            severity: 'warn',
                            detail: 'Vous devez avoir un compte transporteur pour acceder à yamsmanager',
                            life: 5000
                        });
                    }

                }
                else {
                    this.$toast.add({
                        severity: 'warn',
                        detail: response.data.errors[0],
                        life: 5000
                    });
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        resetForm() {
            this.form = {
                email: '',
                password: ''
            }
        }
    }
}
</script>

<style>
.login-box {
    min-width: 300px;
    max-width: 350px;
    margin: auto;
}
</style>